export enum TSMusterDokumentTyp {
    KORRESPONDENZ_MUSTERDOKUMENT = 'KORRESPONDENZ_MUSTERDOKUMENT',
    FREIGABEQUITTUNG_MUSTERDOKUMENT = 'FREIGABEQUITTUNG_MUSTERDOKUMENT'
}
